import mountReactApp from 'mount-react-app';
import {routes, reducers, GlobalStyles as DHotelsGlobalStyles} from 'hotels-dweb';

import {appConfig} from '../hotels/hotels-config/src/index';
import addDays from '../packages/date-utils/src/addDays';
import compareDates from '../packages/date-utils/src/compareDates';

function renderApp() {
  const {defaultCheckinOffset, defaultCheckoutOffset} = appConfig;

  const initialState = window.__initial_state__;
  initialState.common.checkin.date = new Date(initialState.common.checkin.date);
  initialState.common.checkout.date = new Date(initialState.common.checkout.date);

  if (compareDates(initialState.common.checkin.date, new Date(), (a, b) => a < b)) {
    initialState.common.checkin.date = addDays(new Date(), defaultCheckinOffset);
  }

  if (compareDates(initialState.common.checkout.date, new Date(), (a, b) => a < b)) {
    initialState.common.checkout.date = addDays(new Date(), defaultCheckoutOffset);
  }

  mountReactApp({routes, reducers, CustomGlobalStyle: DHotelsGlobalStyles, initialState});
}

renderApp();

if (module.hot) {
  module.hot.accept('hotels-dweb', () => renderApp());
}
